
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
  <path
    fill="currentColor"
    d="M585.671111 597.333333h-455.111111V142.222222h455.111111z m56.888889-512h-568.888889v568.888889h568.888889zM699.448889 483.555556v227.555555h-227.555556v227.555556h455.111111V483.555556h-227.555555z"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'SendBackward',
    }) as DefineComponent
    </script>
    